import axios from "axios";
import { apiBase } from "@/constants";

export default {
  state: {
    loginEmail: '',
    loginPassword: '',
    loginRemember: false,
    loginCredentialsValid: true,
    loginSessionExpired: false
  },
  getters: {
    loginEmail: state => state.loginEmail,
    loginPassword: state => state.loginPassword,
    loginRemember: state => state.loginRemember,
    loginFormFilled: state => state.loginEmail.length > 0 && state.loginPassword.length > 0,
    loginCredentialsValid: state => state.loginCredentialsValid,
    loginSessionExpired: state => state.loginSessionExpired
  },
  mutations: {
    updateLoginEmail(state, value) {
      state.loginEmail = value;
    },
    updateLoginPassword(state, value) {
      state.loginPassword = value;
    },
    updateLoginRemember(state, value) {
      state.loginRemember = value;
    },
    setLoginSessionExpired(state) {
      state.loginSessionExpired = true;
    },
    setLoginCredentialsInvalid(state) {
      state.loginCredentialsValid = false;
    },
    clearLoginErrors(state) {
      state.loginCredentialsValid = true;
      state.loginSessionExpired = false;
    },
    fillLoginWithRegistrationDetails(state, payload) {
      state.loginEmail = payload.registrationEmail;
      state.loginPassword = payload.registrationPassword;
      state.loginRemember = true;
    }
  },
  actions: {
    login: ({ commit, state, dispatch }) => new Promise((resolve) => {
      dispatch('clearAllAuthErrors');
      commit('setLoadingMessage', 'Trwa logowanie...');
      commit('setLoading', true);
      localStorage.setItem('remember', state.loginRemember);
      axios.post(`${apiBase}/login`,
        {
          email: state.loginEmail,
          password: state.loginPassword
        })
        .then((response) => {
          if (response.status === 200) {
            const { accessToken, refreshToken } = response.data;
            localStorage.setItem('access-token', accessToken);
            localStorage.setItem('refresh-token', refreshToken);
            axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
            commit('setLoadingMessage', '');
            commit('setLoading', false);
            commit('login');
            resolve(response);
          }
        })
        .catch((err) => {
          commit('setLoadingMessage', '');
          commit('setLoading', false);
          if (err.response === undefined) commit('setConnectionAuthError');
          else if (err.response.status === 400
        && err.response.data.code === 'invalid_credentials') {
            commit('setLoginCredentialsInvalid');
          } else commit('setUnknownAuthError');
          localStorage.removeItem('access-token');
          localStorage.removeItem('remember');
          localStorage.removeItem('refresh-token');
        });
    })
  }
};
